import React from "react";
import Link from "gatsby-link";
import Icon from "../Icon";
import { formatDate } from "../../util/helperFunctions";

const BackBannerBlockNews = ({ page }) => {
  return (
    <div className="banner--back-block flex flex-column w-100 mw-1060 center">
      <Link
        to="/news/"
        className="banner--back-block__link flex items-center justify-center grey1 ttu pv1 pv2-l w-100"
      >
        <Icon
          path="arrow-left"
          width="32"
          height="18"
          className="banner--back-block__icon flex items-center"
        />
        <p className="ml1 mb0 h-5">News</p>
      </Link>
      <div className="banner--back-block__info bg-peach flex flex-column items-center pt3 pt6-l">
        <div className="w-calc-64 mw-696">
          <h2 className="tl h-2--small h-2--l mb1">
            {page.eventDate && formatDate(page.eventDate)}
          </h2>
          <h1 className="banner--back-block__info--headline dark h-2 h-1--l tl">
            {page.title}
          </h1>
        </div>
      </div>
    </div>
  );
};

export default BackBannerBlockNews;



// WEBPACK FOOTER //
// ./src/components/Banners/BackBannerBlockNews.js